import { IdNameValue, InfluencerCategory, InfluencerInfoRdo, InfluencerStatisticsDetailRdo, QueryResponse, RegionRdo, CommandResponse, MediaInsightRdo, InstagramMediaSnapshot } from '@/models';
import axios from 'axios';
import {
  FindInfluencerByIdQuery,
  FindInfluencerByUsernameQuery,
  FindActiveInfluencersQuery,
  FindPreActiveInfluencersQuery,
  FindInfluencerCategoriesQuery,
  FindAllInfluencersQuery,
  FindInfluencerStatisticsQuery,
  FindAllRegionsQuery,
  FindInfluencerPostInsightsQuery,
  FindPostWeeklyInsightsQuery,
  FindDemographicBreakdownQuery,
  SyncInstagramMediaSnapshotsByIdsAdmCommand,
  SyncInstagramMediaInsightsAdmCommand,
} from '@/apis';

const url = (path: string) => `/api/feature/adm/influencer/${path}`;

const findInfluencerById = async (query: FindInfluencerByIdQuery): Promise<QueryResponse<InfluencerInfoRdo>> => {
  //
  const response = await axios.post<QueryResponse<InfluencerInfoRdo>>(url('find-influencer-by-id/query'), query);
  return response.data;
};

const findInfluencerByUsername = async (query: FindInfluencerByUsernameQuery): Promise<QueryResponse<InfluencerInfoRdo>> => {
  //
  const response = await axios.post<QueryResponse<InfluencerInfoRdo>>(url('find-influencer-by-username/query'), query);
  return response.data;
};

const findActiveInfluencers = async (query: FindActiveInfluencersQuery): Promise<QueryResponse<InfluencerInfoRdo[]>> => {
  //
  const response = await axios.post<QueryResponse<InfluencerInfoRdo[]>>(url('find-active-influencers/query'), query);
  return response.data;
};

const findPreActiveInfluencers = async (query: FindPreActiveInfluencersQuery): Promise<QueryResponse<InfluencerInfoRdo[]>> => {
  //
  const response = await axios.post<QueryResponse<InfluencerInfoRdo[]>>(url('find-pre-active-influencers/query'), query);
  return response.data;
};

const findInfluencerCategories = async (query: FindInfluencerCategoriesQuery): Promise<QueryResponse<InfluencerCategory[]>> => {
  //
  const response = await axios.post<QueryResponse<InfluencerCategory[]>>(url('find-influencer-categories/query'), query);
  return response.data;
};

const findAllInfluencers = async (query: FindAllInfluencersQuery): Promise<QueryResponse<IdNameValue[]>> => {
  //
  const response = await axios.post<QueryResponse<IdNameValue[]>>(url('find-all-influencers/query'), query);
  return response.data;
};

const findInfluencerDetail = async (query: FindInfluencerByIdQuery): Promise<QueryResponse<InfluencerInfoRdo>> => {
  //
  const response = await axios.post<QueryResponse<InfluencerInfoRdo>>(url('find-influencer-detail/query'), query);
  return response.data;
};

const findInfluencerStatistics = async (query: FindInfluencerStatisticsQuery): Promise<QueryResponse<InfluencerStatisticsDetailRdo>> => {
  //
  const response = await axios.post<QueryResponse<InfluencerStatisticsDetailRdo>>(url('find-influencer-statistics/query'), query);
  return response.data;
};

const findAllRegions = async (query: FindAllRegionsQuery = {}): Promise<QueryResponse<RegionRdo[]>> => {
  //
  const response = await axios.post<QueryResponse<RegionRdo[]>>(url('find-all-regions/query'), query);
  return response.data;
};

// --- Instagram media insights ---

const findInfluencerPostInsights = async (query: FindInfluencerPostInsightsQuery): Promise<QueryResponse<MediaInsightRdo[]>> => {
  //
  const response = await axios.post<QueryResponse<MediaInsightRdo[]>>(url('find-influencer-post-insights/query'), query);
  return response.data;
};

const findPostWeeklyInsights = async (query: FindPostWeeklyInsightsQuery): Promise<QueryResponse<MediaInsightRdo[]>> => {
  //
  const response = await axios.post<QueryResponse<MediaInsightRdo[]>>(url('find-post-weekly-insights/query'), query);
  return response.data;
};

const syncInfluencerMediaInsights = async (command: SyncInstagramMediaInsightsAdmCommand): Promise<CommandResponse<MediaInsightRdo[]>> => {
  //
  const response = await axios.post<CommandResponse<MediaInsightRdo[]>>(url('sync-influencer-media-insights/command'), command);
  return response.data;
};

const syncInfluencerMediaSnapshotsByIds = async (command: SyncInstagramMediaSnapshotsByIdsAdmCommand): Promise<CommandResponse<InstagramMediaSnapshot[]>> => {
  //
  const response = await axios.post<CommandResponse<InstagramMediaSnapshot[]>>(url('sync-influencer-media-snapshots-by-ids/command'), command);
  return response.data;
};

const findDemographicBreakdown = async (query: FindDemographicBreakdownQuery): Promise<QueryResponse<Record<string, number>>> => {
  //
  const response = await axios.post<QueryResponse<Record<string, number>>>(url('find-influencer-demographic-breakdown/query'), query);
  return response.data;
};


export default {
  findInfluencerById,
  findInfluencerByUsername,
  findActiveInfluencers,
  findPreActiveInfluencers,
  findInfluencerCategories,
  findAllInfluencers,
  findInfluencerDetail,
  findInfluencerStatistics,
  findAllRegions,
  findInfluencerPostInsights,
  findPostWeeklyInsights,
  syncInfluencerMediaInsights,
  syncInfluencerMediaSnapshotsByIds,
  findDemographicBreakdown,
};
